import { normalizePageTabId } from '@/common/composables/useFormStates'

/** Разметка формы: корень `form` или вложенный `form.form` (как Form.vue). */
export function resolveFormLayoutObject(pageData: unknown): Record<string, any> {
  const f = (pageData as { form?: unknown })?.form
  if (!f || typeof f !== 'object' || Array.isArray(f)) {
    return {}
  }
  const form = f as Record<string, any>
  const topHasLayout = Array.isArray(form.main) && form.main.length > 0
  if (topHasLayout) {
    return form
  }
  const inner = form.form
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
    const innerForm = inner as Record<string, any>
    const innerHasLayout = Array.isArray(innerForm.main) && innerForm.main.length > 0
    if (innerHasLayout) {
      return { ...form, ...innerForm }
    }
  }
  return form
}

function pageIdFromLayoutPage(page: unknown): string {
  if (page == null || typeof page !== 'object') return ''
  const p = page as Record<string, any>
  return normalizePageTabId(p.id ?? p._attributes?.id)
}

/** Страницы колонок main[1..] (правая панель «Состав смены» и т.п.). */
export function collectSecondaryMainColumnPageIds(formObj: Record<string, any>): Set<string> {
  const out = new Set<string>()
  const mains = formObj?.main
  if (!Array.isArray(mains) || mains.length < 2) {
    return out
  }
  for (let i = 1; i < mains.length; i++) {
    const region = mains[i]
    if (!Array.isArray(region)) continue
    for (const page of region) {
      const id = pageIdFromLayoutPage(page)
      if (id) out.add(id)
    }
  }
  return out
}

function primaryMainPageCount(formObj: Record<string, any>): number {
  const mains = formObj?.main
  if (!Array.isArray(mains) || mains.length === 0) return 0
  const first = mains[0]
  return Array.isArray(first) ? first.length : 0
}

/**
 * Swing: боковая колонка (второй <main>) всегда на экране — reload не привязан к вкладке PAGE слева.
 * Guard только для вкладок в первой колонке, если их больше одной.
 */
export function shouldApplyPageFocusGuardForReload(
  registeredPageId: unknown,
  pageData: unknown,
): boolean {
  const pageKey = normalizePageTabId(registeredPageId as string | number)
  if (!pageKey) return false

  const formObj = resolveFormLayoutObject(pageData)
  const secondaryIds = collectSecondaryMainColumnPageIds(formObj)
  if (secondaryIds.has(pageKey)) {
    return false
  }

  return primaryMainPageCount(formObj) > 1
}
